module.exports = __webpack_public_path__ + "static/media/uwc-logo.e0bd117f.png";